import { utils, writeFile } from "xlsx";

/**
 * Exports data to an Excel file.
 *
 * @param {{data: T[]; fileName?: string; sheetName?: string; writeFileOptions?: WritingOptions; fileNameWithTimeStamp?: boolean}} params - The parameters for exporting the data.
 * @param {T[]} params.data - The data to be exported.
 * @param {string} [params.fileName] - The name of the exported file. If not provided, a timestamp will be used.
 * @param {string} [params.sheetName="sheet1"] - The name of the sheet in the exported file.
 * @param {WritingOptions} [params.writeFileOptions={}] - The options for writing the file.
 * @param {boolean} [params.fileNameWithTimeStamp=false] - Whether to include a timestamp in the file name.
 * @throws {Error} If the data is not provided or is empty.
 * @return {void}
 */
export function exportDataToExcel(params) {
  try {
    const {
      data,
      fileName,
      sheetName = "sheet1",
      writeFileOptions = {},
      fileNameWithTimeStamp = false,
      isDataTypeAoa = false,
    } = params;

    if (!data || data.length === 0) {
      throw new Error("Data is not found!");
    }

    const nowTime = new Date();
    const MM = nowTime.getMonth() + 1; // getMonth() is zero-based
    const dd = nowTime.getDate();
    const hh = nowTime.getHours();
    const mm = nowTime.getMinutes();
    const ss = nowTime.getSeconds();

    const nowTimeString = [
      nowTime.getFullYear(),
      (MM > 9 ? "" : "0") + MM,
      (dd > 9 ? "" : "0") + dd,
      "_",
      (hh > 9 ? "" : "0") + hh,
      (mm > 9 ? "" : "0") + mm,
      (ss > 9 ? "" : "0") + ss,
    ].join("");

    const fileExtension = ".xlsx";

    const formatedFileName = fileName
      ? fileName +
        (fileNameWithTimeStamp ? "_" + nowTimeString : "") +
        fileExtension
      : nowTimeString + fileExtension;

    const worksheet = isDataTypeAoa
      ? utils.aoa_to_sheet(data)
      : utils.json_to_sheet(data);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, sheetName);

    writeFile(workbook, formatedFileName, writeFileOptions);
  } catch (ex) {
    console.log(ex);
    window.alert("Export error: " + ex.message);
  }
}
